import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { IChildAccountEditProps } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/ChildAccountTable/ChildAccountEdit/ChildAccountEdit';

export interface ChildAccountNameInputTextProps {
  name: string;
  id: string;
}

export function ChildAccountNameInputText({
  name,
  id,
}: ChildAccountNameInputTextProps): JSX.Element {
  const { errors, control } = useFormContext<IChildAccountEditProps>();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      inputSize="medium"
      control={control}
      error={errors[name]}
      blockWidth
      aria-label={name}
      data-testid={`${name}-input`}
      rules={{
        required: 'Child account name is required',
      }}
    />
  );
}
